
// src/actions/groups.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_GROUPS = "FETCH_GROUPS"
export const FETCH_GROUPS_REQUESTED = "FETCH_GROUPS_REQUESTED"
export const FETCH_GROUPS_COMPLETED = "FETCH_GROUPS_COMPLETED"
export const FETCH_GROUPS_FAILED = "FETCH_GROUPS_FAILED"

export function fetchGroupsRequested() {
  return {
    type: FETCH_GROUPS_REQUESTED
  }
}

export function fetchGroups() {
  return function(dispatch) {
    dispatch(fetchGroupsRequested())
    return api.get(`/groups`)
        .then((results)=> {
          dispatch(fetchGroupsCompleted(results))
          dispatch(fetchAllUnreadCount())
          // 取得したグループのうち、所属グループとお気に入りの未読件数を取得する
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchGroupsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchGroupsCompleted(results) {
  return {
    type: FETCH_GROUPS_COMPLETED,
    results,
  }
}

export function fetchGroupsFailed(error) {
  return {
    type: FETCH_GROUPS_FAILED,
    error,
  }
}

export const FETCH_GROUP_UNREAD_COUNT = "FETCH_GROUP_UNREAD_COUNT"
export const FETCH_GROUP_UNREAD_COUNT_REQUESTED = "FETCH_GROUP_UNREAD_COUNT_REQUESTED"
export const FETCH_GROUP_UNREAD_COUNT_COMPLETED = "FETCH_GROUP_UNREAD_COUNT_COMPLETED"
export const FETCH_GROUP_UNREAD_COUNT_FAILED = "FETCH_GROUP_UNREAD_COUNT_FAILED"

export function fetchGroupUnreadCountRequested() {
  return {
    type: FETCH_GROUP_UNREAD_COUNT_REQUESTED
  }
}

export function fetchGroupUnreadCount(group_id) {
  return function(dispatch) {
    dispatch(fetchGroupUnreadCountRequested())
    return api.get(`/diaries/unreads`, { group_id })
        .then((results)=> {
          dispatch(fetchGroupUnreadCountCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchGroupUnreadCountFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchGroupUnreadCountCompleted(results) {
  return {
    type: FETCH_GROUP_UNREAD_COUNT_COMPLETED,
    results,
  }
}

export function fetchGroupUnreadCountFailed(error) {
  return {
    type: FETCH_GROUP_UNREAD_COUNT_FAILED,
    error,
  }
}

export const FETCH_ALL_UNREAD_COUNT = "FETCH_ALL_UNREAD_COUNT"
export const FETCH_ALL_UNREAD_COUNT_REQUESTED = "FETCH_ALL_UNREAD_COUNT_REQUESTED"
export const FETCH_ALL_UNREAD_COUNT_COMPLETED = "FETCH_ALL_UNREAD_COUNT_COMPLETED"
export const FETCH_ALL_UNREAD_COUNT_FAILED = "FETCH_ALL_UNREAD_COUNT_FAILED"

export function fetchAllUnreadCountRequested() {
  return {
    type: FETCH_ALL_UNREAD_COUNT_REQUESTED
  }
}

export function fetchAllUnreadCount() {
  return function(dispatch) {
    dispatch(fetchAllUnreadCountRequested())
    return api.get(`/home_diaries/unreads`)
        .then((results)=> {
          dispatch(fetchAllUnreadCountCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchAllUnreadCountFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchAllUnreadCountCompleted(results) {
  return {
    type: FETCH_ALL_UNREAD_COUNT_COMPLETED,
    results,
  }
}

export function fetchAllUnreadCountFailed(error) {
  return {
    type: FETCH_ALL_UNREAD_COUNT_FAILED,
    error,
  }
}

export const FETCH_GROUP = "FETCH_GROUP"
export const FETCH_GROUP_REQUESTED = "FETCH_GROUP_REQUESTED"
export const FETCH_GROUP_COMPLETED = "FETCH_GROUP_COMPLETED"
export const FETCH_GROUP_FAILED = "FETCH_GROUP_FAILED"

export function fetchGroupRequested() {
  return {
    type: FETCH_GROUP_REQUESTED
  }
}

export function fetchGroup(group_id) {
  return function(dispatch) {
    dispatch(fetchGroupRequested())
    return api.get(`/groups/${group_id}`)
        .then((results)=> {
          dispatch(fetchGroupCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchGroupFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchGroupCompleted(results) {
  return {
    type: FETCH_GROUP_COMPLETED,
    results,
  }
}

export function fetchGroupFailed(error) {
  return {
    type: FETCH_GROUP_FAILED,
    error,
  }
}

export const CREATE_GROUP = "CREATE_GROUP"
export const CREATE_GROUP_REQUESTED = "CREATE_GROUP_REQUESTED"
export const CREATE_GROUP_COMPLETED = "CREATE_GROUP_COMPLETED"
export const CREATE_GROUP_FAILED = "CREATE_GROUP_FAILED"

export function createGroupRequested() {
  return {
    type: CREATE_GROUP_REQUESTED
  }
}

export function createGroup(name, access_type, uploadable_file_id, crop, description, organization_id, cancel_remind_mail, locale) {
  return function(dispatch) {
    dispatch(createGroupRequested())
    return api.post(`/groups`, { name, access_type, uploadable_file_id, crop, description, organization_id, cancel_remind_mail, locale })
        .then((results)=> {
          dispatch(createGroupCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(createGroupFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function createGroupCompleted(results) {
  return {
    type: CREATE_GROUP_COMPLETED,
    results,
  }
}

export function createGroupFailed(error) {
  return {
    type: CREATE_GROUP_FAILED,
    error,
  }
}

export const UPDATE_GROUP = "UPDATE_GROUP"
export const UPDATE_GROUP_REQUESTED = "UPDATE_GROUP_REQUESTED"
export const UPDATE_GROUP_COMPLETED = "UPDATE_GROUP_COMPLETED"
export const UPDATE_GROUP_FAILED = "UPDATE_GROUP_FAILED"

export function updateGroupRequested() {
  return {
    type: UPDATE_GROUP_REQUESTED
  }
}

export function updateGroup(group_id, name, access_type, uploadable_file_id, crop, description, locale) {
  return function(dispatch) {
    dispatch(updateGroupRequested())
    return api.put(`/groups/${group_id}`, { name, access_type, uploadable_file_id, crop, description, locale })
        .then((results)=> {
          dispatch(updateGroupCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateGroupFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateGroupCompleted(results) {
  return {
    type: UPDATE_GROUP_COMPLETED,
    results,
  }
}

export function updateGroupFailed(error) {
  return {
    type: UPDATE_GROUP_FAILED,
    error,
  }
}

export const FETCH_SCHEDULED_SETTINGS = "FETCH_SCHEDULED_SETTINGS"
export const FETCH_SCHEDULED_SETTINGS_REQUESTED = "FETCH_SCHEDULED_SETTINGS_REQUESTED"
export const FETCH_SCHEDULED_SETTINGS_COMPLETED = "FETCH_SCHEDULED_SETTINGS_COMPLETED"
export const FETCH_SCHEDULED_SETTINGS_FAILED = "FETCH_SCHEDULED_SETTINGS_FAILED"

export function fetchScheduledSettingsRequested() {
  return {
    type: FETCH_SCHEDULED_SETTINGS_REQUESTED
  }
}

export function fetchScheduledSettings(group_id) {
  return function(dispatch) {
    dispatch(fetchScheduledSettingsRequested())

    // Get the scheduled settings
    return api.get(`/group_memberships/settings/${group_id}`)
      .then((results)=> {
        dispatch(fetchScheduledSettingsCompleted(results));
      })
      .catch((error)=> {
        Promise.all([
          dispatch(fetchScheduledSettingsFailed(error)),
          dispatch(emitAlertMessage('error:fetch-scheduled-settings', 'error'))
        ])
      })
  }
}

export function fetchScheduledSettingsCompleted(results) {
  return {
    type: FETCH_SCHEDULED_SETTINGS_COMPLETED,
    results,
  }
}

export function fetchScheduledSettingsFailed(error) {
  return {
    type: FETCH_SCHEDULED_SETTINGS_FAILED,
    error,
  }
}

export const CLEAR_SCHEDULED_SETTINGS = "CLEAR_SCHEDULED_SETTINGS"

export function clearScheduledSettings() {
  return {
    type: CLEAR_SCHEDULED_SETTINGS
  }
}

export const UPDATE_SCHEDULED_SETTINGS = "UPDATE_SCHEDULED_SETTINGS"
export const UPDATE_SCHEDULED_SETTINGS_REQUESTED = "UPDATE_SCHEDULED_SETTINGS_REQUESTED"
export const UPDATE_SCHEDULED_SETTINGS_COMPLETED = "UPDATE_SCHEDULED_SETTINGS_COMPLETED"
export const UPDATE_SCHEDULED_SETTINGS_FAILED = "UPDATE_SCHEDULED_SETTINGS_FAILED"

export function updateScheduledSettingsRequested() {
  return {
    type: UPDATE_SCHEDULED_SETTINGS_REQUESTED
  }
}

export function updateScheduledSettings(group_id, refresh_token, is_active, folder_id, interval, generate_next_at, access_token ) {
  return function(dispatch) {
    dispatch(updateScheduledSettingsRequested())

    // Update the scheduled settings
    return api.post(`/group_memberships/settings/${group_id}`, { refresh_token, is_active, folder_id, interval, generate_next_at, access_token })
      .then((results)=> {
        dispatch(updateScheduledSettingsCompleted(results));
        dispatch(emitAlertMessage('定期実行設定が更新されました。', 'success'))
      })
      .catch((error)=> {
        Promise.all([
          dispatch(updateScheduledSettingsFailed(error)),
          dispatch(emitAlertMessage('error:update-scheduled-settings', 'error'))
        ])
      })
  }
}

export function updateScheduledSettingsCompleted(results) {
  return {
    type: UPDATE_SCHEDULED_SETTINGS_COMPLETED,
    results,
  }
}

export function updateScheduledSettingsFailed(error) {
  return {
    type: UPDATE_SCHEDULED_SETTINGS_FAILED,
    error,
  }
}

export const UPDATE_GROUP_MEMBERSHIP = "UPDATE_GROUP_MEMBERSHIP"
export const UPDATE_GROUP_MEMBERSHIP_REQUESTED = "UPDATE_GROUP_MEMBERSHIP_REQUESTED"
export const UPDATE_GROUP_MEMBERSHIP_COMPLETED = "UPDATE_GROUP_MEMBERSHIP_COMPLETED"
export const UPDATE_GROUP_MEMBERSHIP_FAILED = "UPDATE_GROUP_MEMBERSHIP_FAILED"

export function updateGroupMembershipRequested() {
  return {
    type: UPDATE_GROUP_MEMBERSHIP_REQUESTED
  }
}

export function updateGroupMembership(group_id, user_id, membership) {
  return function(dispatch) {
    dispatch(updateGroupMembershipRequested())
    return api.put(`/group_memberships/${group_id}/members/${user_id}`, { membership })
        .then((results)=> {
          dispatch(updateGroupMembershipCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateGroupMembershipFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateGroupMembershipCompleted(results) {
  return {
    type: UPDATE_GROUP_MEMBERSHIP_COMPLETED,
    results,
  }
}

export function updateGroupMembershipFailed(error) {
  return {
    type: UPDATE_GROUP_MEMBERSHIP_FAILED,
    error,
  }
}

export const SORT_GROUP_MEMBERS = "SORT_GROUP_MEMBERS"
export const SORT_GROUP_MEMBERS_REQUESTED = "SORT_GROUP_MEMBERS_REQUESTED"
export const SORT_GROUP_MEMBERS_COMPLETED = "SORT_GROUP_MEMBERS_COMPLETED"
export const SORT_GROUP_MEMBERS_FAILED = "SORT_GROUP_MEMBERS_FAILED"

export function sortGroupMembersRequested() {
  return {
    type: SORT_GROUP_MEMBERS_REQUESTED
  }
}

export function sortGroupMembers(group_id, sort_order) {
  return function(dispatch) {
    dispatch(sortGroupMembersRequested())
    return api.put(`/group_memberships/sort/${group_id}`, { sort_order })
        .then((results)=> {
          dispatch(sortGroupMembersCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(sortGroupMembersFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function sortGroupMembersCompleted(results) {
  return {
    type: SORT_GROUP_MEMBERS_COMPLETED,
    results,
  }
}

export function sortGroupMembersFailed(error) {
  return {
    type: SORT_GROUP_MEMBERS_FAILED,
    error,
  }
}

export const SORT_GROUPS = "SORT_GROUPS"
export const SORT_GROUPS_REQUESTED = "SORT_GROUPS_REQUESTED"
export const SORT_GROUPS_COMPLETED = "SORT_GROUPS_COMPLETED"
export const SORT_GROUPS_FAILED = "SORT_GROUPS_FAILED"

export function sortGroupsRequested() {
  return {
    type: SORT_GROUPS_REQUESTED
  }
}

export function sortGroups(sort_order) {
  return function(dispatch) {
    dispatch(sortGroupsRequested())
    return api.put(`/groups/sort`, { sort_order })
        .then((results)=> {
          dispatch(sortGroupsCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(sortGroupsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function sortGroupsCompleted(results) {
  return {
    type: SORT_GROUPS_COMPLETED,
    results,
  }
}

export function sortGroupsFailed(error) {
  return {
    type: SORT_GROUPS_FAILED,
    error,
  }
}

export const DELETE_GROUP = "DELETE_GROUP"
export const DELETE_GROUP_REQUESTED = "DELETE_GROUP_REQUESTED"
export const DELETE_GROUP_COMPLETED = "DELETE_GROUP_COMPLETED"
export const DELETE_GROUP_FAILED = "DELETE_GROUP_FAILED"

export function deleteGroupRequested() {
  return {
    type: DELETE_GROUP_REQUESTED
  }
}

export function deleteGroup(group_id) {
  return function(dispatch) {
    dispatch(deleteGroupRequested())
    return api.delete(`/groups/${group_id}`)
        .then((results)=> {
          dispatch(deleteGroupCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(deleteGroupFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function deleteGroupCompleted(results) {
  return {
    type: DELETE_GROUP_COMPLETED,
    results,
  }
}

export function deleteGroupFailed(error) {
  return {
    type: DELETE_GROUP_FAILED,
    error,
  }
}

export const MERGE_GROUP = "MERGE_GROUP"
export const MERGE_GROUP_REQUESTED = "MERGE_GROUP_REQUESTED"
export const MERGE_GROUP_COMPLETED = "MERGE_GROUP_COMPLETED"
export const MERGE_GROUP_FAILED = "MERGE_GROUP_FAILED"

export function mergeGroupRequested() {
  return {
    type: MERGE_GROUP_REQUESTED
  }
}

export function mergeGroup(group_id, to_group_id) {
  return function(dispatch) {
    dispatch(mergeGroupRequested())
    return api.put(`/groups/${group_id}/merge/${to_group_id}`)
        .then((results)=> {
          dispatch(mergeGroupCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(mergeGroupFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function mergeGroupCompleted(results) {
  return {
    type: MERGE_GROUP_COMPLETED,
    results,
  }
}

export function mergeGroupFailed(error) {
  return {
    type: MERGE_GROUP_FAILED,
    error,
  }
}

export const FETCH_REMIND_MAIL_SETTINGS = "FETCH_REMIND_MAIL_SETTINGS"
export const FETCH_REMIND_MAIL_SETTINGS_REQUESTED = "FETCH_REMIND_MAIL_SETTINGS_REQUESTED"
export const FETCH_REMIND_MAIL_SETTINGS_COMPLETED = "FETCH_REMIND_MAIL_SETTINGS_COMPLETED"
export const FETCH_REMIND_MAIL_SETTINGS_FAILED = "FETCH_REMIND_MAIL_SETTINGS_FAILED"

export function fetchRemindMailSettingsRequested() {
  return {
    type: FETCH_REMIND_MAIL_SETTINGS_REQUESTED
  }
}

export function fetchRemindMailSettings(group_id) {
  return function(dispatch) {
    dispatch(fetchRemindMailSettingsRequested())
    return api.get(`/remind_mail_settings`, { group_id })
        .then((results)=> {
          dispatch(fetchRemindMailSettingsCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchRemindMailSettingsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchRemindMailSettingsCompleted(results) {
  return {
    type: FETCH_REMIND_MAIL_SETTINGS_COMPLETED,
    results,
  }
}

export function fetchRemindMailSettingsFailed(error) {
  return {
    type: FETCH_REMIND_MAIL_SETTINGS_FAILED,
    error,
  }
}

export const UPDATE_REMIND_MAIL_SETTING = "UPDATE_REMIND_MAIL_SETTING"
export const UPDATE_REMIND_MAIL_SETTING_REQUESTED = "UPDATE_REMIND_MAIL_SETTING_REQUESTED"
export const UPDATE_REMIND_MAIL_SETTING_COMPLETED = "UPDATE_REMIND_MAIL_SETTING_COMPLETED"
export const UPDATE_REMIND_MAIL_SETTING_FAILED = "UPDATE_REMIND_MAIL_SETTING_FAILED"

export function updateRemindMailSettingRequested() {
  return {
    type: UPDATE_REMIND_MAIL_SETTING_REQUESTED
  }
}

export function updateRemindMailSetting(group_id, user_id, delivery) {
  return function(dispatch) {
    dispatch(updateRemindMailSettingRequested())
    return api.put(`/remind_mail_settings/${user_id}`, { group_id, delivery })
        .then((results)=> {
          dispatch(updateRemindMailSettingCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateRemindMailSettingFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateRemindMailSettingCompleted(results) {
  return {
    type: UPDATE_REMIND_MAIL_SETTING_COMPLETED,
    results,
  }
}

export function updateRemindMailSettingFailed(error) {
  return {
    type: UPDATE_REMIND_MAIL_SETTING_FAILED,
    error,
  }
}

export const UPDATE_REMIND_MAIL_SCHEDULE = "UPDATE_REMIND_MAIL_SCHEDULE"
export const UPDATE_REMIND_MAIL_SCHEDULE_REQUESTED = "UPDATE_REMIND_MAIL_SCHEDULE_REQUESTED"
export const UPDATE_REMIND_MAIL_SCHEDULE_COMPLETED = "UPDATE_REMIND_MAIL_SCHEDULE_COMPLETED"
export const UPDATE_REMIND_MAIL_SCHEDULE_FAILED = "UPDATE_REMIND_MAIL_SCHEDULE_FAILED"

export function updateRemindMailScheduleRequested() {
  return {
    type: UPDATE_REMIND_MAIL_SCHEDULE_REQUESTED
  }
}

export function updateRemindMailSchedule(group_id, send_on_sun, send_on_mon, send_on_tue, send_on_wed, send_on_thu, send_on_fri, send_on_sat, send_on_holiday, send_at, timezone) {
  return function(dispatch) {
    dispatch(updateRemindMailScheduleRequested())
    return api.put(`/remind_mail_settings/schedule`, { group_id, send_on_sun, send_on_mon, send_on_tue, send_on_wed, send_on_thu, send_on_fri, send_on_sat, send_on_holiday, send_at, timezone })
        .then((results)=> {
          dispatch(updateRemindMailScheduleCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateRemindMailScheduleFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateRemindMailScheduleCompleted(results) {
  return {
    type: UPDATE_REMIND_MAIL_SCHEDULE_COMPLETED,
    results,
  }
}

export function updateRemindMailScheduleFailed(error) {
  return {
    type: UPDATE_REMIND_MAIL_SCHEDULE_FAILED,
    error,
  }
}

export const SEARCH_GROUPS = "SEARCH_GROUPS"

export function searchGroups(query) {
  return {
    type: SEARCH_GROUPS,
    query: query && query.length > 0 ? query : undefined,
  }
}

export const LOAD_GROUP = "LOAD_GROUP"

export function loadGroup(group, opt = {}) {
  return {
    type: LOAD_GROUP,
    group: group,
    deleted: opt.deleted,
  }
}

export const LOAD_GROUP_UNREAD_COUNT = "LOAD_GROUP_UNREAD_COUNT"

export function loadGroupUnreadCount(group_id, unreads) {
  return {
    type: LOAD_GROUP_UNREAD_COUNT,
    group_id, unreads,
  }
}

export const FETCH_ALBUM_LENGTH = 20

export const FETCH_ALBUM_GROUP_IMAGE = "FETCH_ALBUM_GROUP_IMAGE"
export const FETCH_ALBUM_GROUP_IMAGE_REQUESTED = "FETCH_ALBUM_GROUP_IMAGE_REQUESTED"
export const FETCH_ALBUM_GROUP_IMAGE_COMPLETED = "FETCH_ALBUM_GROUP_IMAGE_COMPLETED"
export const FETCH_ALBUM_GROUP_IMAGE_FAILED = "FETCH_ALBUM_GROUP_IMAGE_FAILED"

export function fetchAlbumGroupImageRequested() {
  return {
    type: FETCH_ALBUM_GROUP_IMAGE_REQUESTED
  }
}

export function fetchAlbumGroupImage(group_id, file_type, offset) {
  return function(dispatch) {
    dispatch(fetchAlbumGroupImageRequested())
    return api.get(`/groups/${group_id}/files`,{ file_type, offset, length: FETCH_ALBUM_LENGTH })
        .then((results)=> {
          dispatch(fetchAlbumGroupImageCompleted(results, file_type, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchAlbumGroupImageFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchAlbumGroupImageCompleted(results, file_type, offset) {
  return {
    type: FETCH_ALBUM_GROUP_IMAGE_COMPLETED,
    results, file_type, offset,
  }
}

export function fetchAlbumGroupImageFailed(error) {
  return {
    type: FETCH_ALBUM_GROUP_IMAGE_FAILED,
    error,
  }
}

export const FETCH_ALBUM_GROUP_FILE = "FETCH_ALBUM_GROUP_FILE"
export const FETCH_ALBUM_GROUP_FILE_REQUESTED = "FETCH_ALBUM_GROUP_FILE_REQUESTED"
export const FETCH_ALBUM_GROUP_FILE_COMPLETED = "FETCH_ALBUM_GROUP_FILE_COMPLETED"
export const FETCH_ALBUM_GROUP_FILE_FAILED = "FETCH_ALBUM_GROUP_FILE_FAILED"

export function fetchAlbumGroupFileRequested() {
  return {
    type: FETCH_ALBUM_GROUP_FILE_REQUESTED
  }
}

export function fetchAlbumGroupFile(group_id, file_type, offset) {
  return function(dispatch) {
    dispatch(fetchAlbumGroupFileRequested())
    return api.get(`/groups/${group_id}/files`,{ file_type, offset, length: FETCH_ALBUM_LENGTH })
        .then((results)=> {
          dispatch(fetchAlbumGroupFileCompleted(results, file_type, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchAlbumGroupFileFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchAlbumGroupFileCompleted(results, file_type, offset) {
  return {
    type: FETCH_ALBUM_GROUP_FILE_COMPLETED,
    results, file_type, offset,
  }
}

export function fetchAlbumGroupFileFailed(error) {
  return {
    type: FETCH_ALBUM_GROUP_FILE_FAILED,
    error,
  }
}

export const FETCH_ALBUM_GROUP_VIDEO = "FETCH_ALBUM_GROUP_VIDEO"
export const FETCH_ALBUM_GROUP_VIDEO_REQUESTED = "FETCH_ALBUM_GROUP_VIDEO_REQUESTED"
export const FETCH_ALBUM_GROUP_VIDEO_COMPLETED = "FETCH_ALBUM_GROUP_VIDEO_COMPLETED"
export const FETCH_ALBUM_GROUP_VIDEO_FAILED = "FETCH_ALBUM_GROUP_VIDEO_FAILED"

export function fetchAlbumGroupVideoRequested() {
  return {
    type: FETCH_ALBUM_GROUP_VIDEO_REQUESTED
  }
}

export function fetchAlbumGroupVideo(group_id, offset) {
  return function(dispatch) {
    dispatch(fetchAlbumGroupVideoRequested())
    return api.get(`/groups/${group_id}/videos`, { offset, length: FETCH_ALBUM_LENGTH })
        .then((results)=> {
          dispatch(fetchAlbumGroupVideoCompleted(results, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchAlbumGroupVideoFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchAlbumGroupVideoCompleted(results, offset) {
  return {
    type: FETCH_ALBUM_GROUP_VIDEO_COMPLETED,
    results, offset,
  }
}

export function fetchAlbumGroupVideoFailed(error) {
  return {
    type: FETCH_ALBUM_GROUP_VIDEO_FAILED,
    error,
  }
}

export const CLEAR_GROUP_ALBUM = "CLEAR_GROUP_ALBUM"

export function clearGroupAlbum() {
  return {
    type: CLEAR_GROUP_ALBUM
  }
}



// WEBPACK FOOTER //
// ./src/actions/groups.js